export default "__VITE_ASSET__B1NKKrj7__"